<template>
  <div id="container" class="main h-100 column gap-3 justify-content-center">
    <div class="column gap-3 text-align-left">
      <p class="body xl font-bold">{{ t('welcome.title') }}</p>
    </div>
    <div class="column gap-3 text-align-left">
      <p class="body">
        {{ t('welcome.ai_complement') }}
      </p>
      <p class="body">{{ t('welcome.login_prompt') }}</p>
    </div>
    <FormButton
      :label="t('welcome.continue')"
      size="large"
      :onClick="navigateToNextScreen"
      class-name="w-100"
      :disabled="loading"
    />
    <NoAccountSection />
  </div>
</template>
<script setup lang="ts">
import NoAccountSection from '@/components/auth/NoAccountSection.vue';
import FormButton from '@/components/common/button/FormButton.vue';
import { useAuthFlow } from '@/composables/useAuthFlow';
import RouteNames from '@/configuration/router/names.routes';
import { spainAuthenticationEndpoints } from '@/core/endpoints';
import navigationService from '@/services/NavigationService';
import { useToasterStore } from '@/stores/useToasterStore';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const toaster = useToasterStore();
const { processSpanishAuth } = useAuthFlow();
const loading = ref(false);

const navigateToNextScreen = async () => {
  const backendLoginUrl = `${process.env.VUE_APP_API_URL}${spainAuthenticationEndpoints.LOGIN}`;

  Office.context.ui.displayDialogAsync(
    backendLoginUrl,
    { height: 80, width: 80, promptBeforeOpen: false },
    (asyncResult) => {
      const dialog = asyncResult.value;
      loading.value = true;
      dialog.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
        if ('message' in arg && arg.message.includes('ok')) {
          dialog.close();
          checkIfAuthenticated();
        }
      });
      dialog.addEventHandler(Office.EventType.DialogEventReceived, () => {
        dialog.close();
        loading.value = false;
      });
    }
  );
};

async function checkIfAuthenticated() {
  try {
    loading.value = true;

    const isAuthenticated = await processSpanishAuth();

    if (!isAuthenticated) throw new Error('Error authenticating the user');

    toaster.success({
      title: t('authentication.spain.success.title')
    });

    navigationService.navigateTo({ name: RouteNames.Home });
  } catch (err) {
    console.error(err);
    toaster.error({
      title: t('authentication.spain.error.title'),
      body: t('authentication.spain.error.body')
    });
  } finally {
    loading.value = false;
  }
}
</script>
<style scoped lang="scss">
.main {
  width: inherit;
  position: relative;
  overflow: hidden;
}

.main::before {
  content: '';
  position: fixed;
  top: 0;
  right: 0;
  width: $bg-login-width;
  height: 100%;
  background-image: url('@/assets/bg-design.svg');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: top right;
  z-index: -1;
}
</style>
